import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";

import lineStyles from "../../constants/lineStyles";
import { PropTypeShapes } from "../../types";

const SubwayLine = props => {
  const left = _.reduce(props.vertices, (m, p) => (p.x < m ? p.x : m), props.vertices[0].x);
  const top = _.reduce(props.vertices, (m, p) => (p.y < m ? p.y : m), props.vertices[0].y);
  const right = _.reduce(props.vertices, (m, p) => (p.x > m ? p.x : m), props.vertices[0].x);
  const bottom = _.reduce(props.vertices, (m, p) => (p.y > m ? p.y : m), props.vertices[0].y);

  const width = Math.max(right - left, 1);
  const height = Math.max(bottom - top, 1);

  // adjust to get relative position from boundary of SVG
  const vertices = props.vertices.map(p => {
    return { x: p.x - left, y: p.y - top };
  });
  // calculate path from the points
  const path = _.reduce(vertices, (str, p) => `${str} ${str ? "L" : "M"}${p.x} ${p.y}`, "");
  const dashArray =
    props.lineStyle === lineStyles.DASHED
      ? "10,10"
      : props.lineStyle === lineStyles.DOTTED || props.lineStyle === lineStyles.THINDOT
        ? "2,2"
        : props.lineStyle === lineStyles.DOTSPACED
          ? "5,5"
          : props.lineStyle === lineStyles.DOTDASH
            ? "2,5,5,5"
            : null;

  return (
    <svg
      className={`subwayLine ${props.color} ${props.selected ? "selected" : ""}`}
      style={{
        transform: `translate(${left}px,${top}px)`,
        width: `${width}px`,
        height: `${height}px`
      }}
    >
      <path d={path} fill="none" stroke="currentColor" strokeDasharray={dashArray} strokeWidth={props.strokeWidth} />
    </svg>
  );
};

SubwayLine.propTypes = {
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  lineStyle: PropTypes.string.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  vertices: PropTypes.arrayOf(PropTypeShapes.point)
};

export default SubwayLine;
